import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { selectAuthenticatedUser } from 'src/store/selectors/auth';
import { DocumentFormData } from 'src/utils/S3UploadDocumentsUtility';
import DocumentsNewWithLocalState from 'src/components/DocumentsNewLocalState/DocumentsNew';
import Loader from 'src/components/Loader';
import {
  useServiceRequestDataFromContext,
  useServiceRequestActionsFromContext,
} from 'src/pages/ServiceRequest/Context/ServiceRequestContext';

const ServiceRequestDocuments = () => {
  const user = useSelector(selectAuthenticatedUser);

  const { serviceRequest, documents, loadingNotesDocs } =
    useServiceRequestDataFromContext();
  const { saveDocument, deleteDocument, fetchDocuments } =
    useServiceRequestActionsFromContext();

  const onSave = async (document: DocumentFormData): Promise<void> => {
    await saveDocument(document, serviceRequest.id, user.id);
  };

  const onDeleteDocument = async (
    document: DocumentFormData
  ): Promise<void> => {
    await deleteDocument(document, serviceRequest.id);
  };

  return loadingNotesDocs ? (
    <Loader />
  ) : (
    <DocumentsNewWithLocalState
      breadcrumb={serviceRequest.number}
      documents={documents}
      onSaveDocument={(document: DocumentFormData) => onSave(document)}
      onDeleteDocument={(document: any) => onDeleteDocument(document)}
      labelName={'Photos & Documents'}
      disableGrouping={true}
      from={'Service Request'}
      user={user}
    />
  );
};

export default ServiceRequestDocuments;
